import React, { useContext } from 'react';
import Icon, { Icons } from '@shared/Icons/Icon';
import { FilterButton } from '../../FilterButton';
import DiscoveryContext from '../../../../../contexts/discoveryContext/contextV2';
import ClearFilterButton from '../ClearFilterButton';
import { filterButton, icon as iconStyle, bold } from './styles.module.css';

const locationDefaultLabel = 'Location';

const LocationValue = ({ clearFilter, ...props }) => {
  const {
    filters: {
      location: { name },
    },
  } = useContext(DiscoveryContext);

  let label = locationDefaultLabel;

  if (name) {
    label = name;
  }

  const isActive = label !== locationDefaultLabel;
  const icon = isActive ? Icons.LOCATION_WIRE.RED : Icons.LOCATION_WIRE.BLACK;

  return (
    <FilterButton active={isActive} className={filterButton} {...props}>
      <Icon icon={icon} className={iconStyle} />
      <span className={isActive ? bold : undefined}>{label}</span>
      {isActive && <ClearFilterButton onClick={clearFilter} />}
    </FilterButton>
  );
};

export default LocationValue;
